import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/incontrol.webp';
import screenshot_target from '../../../images/letterfunnel/fionagu.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Fiona Gu"
      firstname="Fiona"
      companyname="Incontrol"
      competition="MoreApp en SafetyCulture"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/fionagu.js